import React from "react";

const AddressWhitelistedBadge = () => {
	return <div className="address-whitelisted">Address Whitelisted</div>;
};

export default AddressWhitelistedBadge;
